
export enum Env
{
    Local = "local",
    Stage = "stage",
    Prod = "prod"
}
